<template>
  <div class="setting-view common-view content-view">
    <common-header/>

    <div class="container">
      <div class="back">
        <router-link to="/starterkits/browse">
          <i class="material-icons">arrow_back</i> All
        </router-link>
      </div>

      <starter-kit-detail
        v-if="!isLoading"
        :starterKit="starterKit"
        :styleAssets="styleAssets"
        isScreen
      />
    </div>

    <app-footer/>
  </div>
</template>

<script>
import StarterKitDetail from '../components/starterkit/StarterKitDetail';
import AppFooter from './AppFooter';
import CommonHeader from './CommonHeader';
import { sendRequest } from '../utils/api';

export default {
  components: {
    AppFooter,
    StarterKitDetail,
    CommonHeader,
  },
  data() {
    return {
      isLoading: true,
      starterKit: {},
      styleAssets: [],
    };
  },
  created() {
    sendRequest(`/starter-kit/${this.$route.params.id}?key=000&secret=000`, 'get', {}, {})
      .then((response) => {
        this.starterKit = response.data;

        // get previews for all tab
        const promiseArray = [];
        for (let i = 0; i < this.starterKit['preview-asset-ids'].length; i++) {
          promiseArray.push(sendRequest(
            `/theme-assets/svg/${this.starterKit['preview-asset-ids'][i]}?key=000&secret=000`,
            'get',
            {},
            {},
          ));
        }

        Promise.all(promiseArray)
          .then((assets) => {
            this.styleAssets = assets.map(asset => asset.data);
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
  .container {
    max-width: 900px;
  }

  .content-view {
    @include media($desktop) {
      padding-top: 60px;
    }
  }

  .back {
    margin-bottom: 60px;

    @include media($mobile) {
      margin-bottom: 30px;
    }

    a {
      display: inline-flex;
      align-items: center;
    }

    i {
      margin-right: 10px;
    }
  }

  .app-footer {
    padding: 30px 0;
  }
</style>
